import { AlertCircle } from "lucide-react"

import { cn } from "@/lib/utils"

interface FormErrorProps {
  errors: string[]
  className?: string
}

export function FormError({ errors, className }: FormErrorProps) {
  if (errors.length === 0) return null

  return (
    <div
      role="alert"
      className={cn(
        "flex items-start gap-2 rounded-lg border border-destructive/30 bg-destructive/10 p-3 text-sm text-destructive",
        className,
      )}
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" />
      <ul className="space-y-0.5">
        {errors.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </div>
  )
}
